// src/pages/CreatorProfile.jsx

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../services/api";
import { initiateSupportPayment } from "../services/support";

const CreatorProfile = () => {
  const { displayName } = useParams();

  const [creator, setCreator] = useState(null);
  const [assets, setAssets] = useState([]);
  const [supporters, setSupporters] = useState([]);
  const [loading, setLoading] = useState(true);

  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState(1000);
  const [processing, setProcessing] = useState(false);

  // =========================
  // FETCH CREATOR + ASSETS + SUPPORTERS
  // =========================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await API.get(`/creator-profile/${displayName}`);

        setCreator(res.data.creator);
        setAssets(res.data.assets || []);
        setSupporters(res.data.recent_supporters || []);
      } catch (err) {
        console.error("Creator fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    if (displayName) fetchData();
  }, [displayName]);

  // =========================
  // SUPPORT PAYMENT
  // =========================
  const handleSupport = async () => {
    if (!email) return alert("Enter email");
    if (!amount || amount <= 0) return alert("Invalid amount");

    try {
      setProcessing(true);

      const res = await initiateSupportPayment({
        email,
        slug: displayName,
        amount: Number(amount),
      });

      const link =
        res?.data?.link || res?.link || res?.payment_link;

      if (link) window.location.href = link;
      else alert("Payment link not generated");
    } catch (err) {
      console.error(err);
      alert("Payment failed");
    } finally {
      setProcessing(false);
    }
  };

  if (loading) return <h2 style={{ textAlign: "center" }}>Loading... ⏳</h2>;
  if (!creator) return <h2 style={{ textAlign: "center" }}>Creator not found</h2>;

  return (
    <div className="container">

      {/* =========================
          TRUST BAR (FROM SUPPORT PAGE)
      ========================= */}
      <div
        style={{
          marginTop: 10,
          marginBottom: 20,
          padding: "14px 18px",
          borderRadius: 14,
          background: "#fff",
          border: "2px solid #f1f5f9",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 10,
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <div>
          <b>🔒 Payments Secured by Flutterwave</b>
          <div style={{ fontSize: 13, color: "#6b7280" }}>
            Trusted infrastructure powering creator support payouts.
          </div>
        </div>

        <div
          style={{
            background: "#fb923c",
            color: "#fff",
            padding: "8px 14px",
            borderRadius: 999,
            fontWeight: "bold",
            fontSize: 13,
          }}
        >
          VERIFIED PAYMENT SYSTEM
        </div>
      </div>

      {/* =========================
          CREATOR HEADER
      ========================= */}
      <div className="card">
        <img
          src={creator.profile_image || "https://via.placeholder.com/100"}
          alt={
            creator?.display_name ||
            "creator"
          }
          style={{
            width: 90,
            height: 90,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />

        <h2>@{creator.display_name}</h2>
        <p>{creator.bio || "Creator page"}</p>
      </div>

      {/* =========================
          RECENT SUPPORTERS (REAL DATA)
      ========================= */}
      <div className="card">
        <h3>💚 Recent Supporters</h3>

        {supporters.length === 0 ? (
          <p>No supporters yet</p>
        ) : (
          supporters.slice(0, 10).map((s, i) => (
            <div
              key={i}
              style={{
                padding: 10,
                borderBottom: "1px solid #eee",
                fontSize: 14,
              }}
            >
              <b>{s.email
                ? s.email.replace(
                    /^(.{3}).*(@.*)$/,
                    "$1****$2"
                  )
                : "Anonymous"}
              </b> 
              {" "}
              
              supported ₦{s.amount} • {s.status}
              <br />
              <small>
                {new Date(s.created_at).toLocaleString()}
              </small>
            </div>
          ))
        )}
      </div>

      {/* =========================
          SUPPORT BOX (MVP SIMPLIFIED)
      ========================= */}
      <div className="card">
        <h3>Support Creator</h3>

        <p>Amount</p>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button onClick={() => setAmount(1000)}>☕ ₦1,000</button>
          <button onClick={() => setAmount(5000)}>🍔 ₦5,000</button>
          <button onClick={() => setAmount(10000)}>👑 ₦10,000</button>
          <input
            placeholder="Enter Custom amount"
            type="number"
            className="input"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            style={{ display: "flex", gap: 10, flexWrap: "wrap" }}
          />
        </div>

        <input
          className="input"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ marginTop: 15 }}
        />

        <button
          className="button"
          style={{ marginTop: 15 }}
          disabled={processing}
          onClick={handleSupport}
        >
          {processing ? "Processing..." : `Support ₦${amount}`}
        </button>
      </div>

      {/* =========================
          ASSETS LIST
      ========================= */}
      <div className="card">
        <h3>Creator Content</h3>

        {assets.map((a) => (
          <div key={a.id} style={{ padding: 10, borderBottom: "1px solid #eee" }}>
            <h4>{a.title}</h4>
            <p>{a.description}</p>

            {a.content_link && (
              <button
                onClick={() =>
                  window.open(a.content_link, "_blank", "noopener,noreferrer")
                }
              >
                ▶ View  Profile
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CreatorProfile;